const KEY = 'matrixosExploreSession';

export const defaultExploreState = {
  currentStep: 'start',
  completedSteps: [],
  skippedSteps: [],
  visitedSteps: [],
  industry: '',
  problems: [],
  answers: {},
  chosenLayer: '',
  companyName: '',
  startedAt: null,
  updatedAt: null,
};

export function readExploreSession() {
  if (typeof window === 'undefined') return defaultExploreState;
  try {
    const raw = window.sessionStorage.getItem(KEY);
    if (!raw) return defaultExploreState;
    return { ...defaultExploreState, ...JSON.parse(raw) };
  } catch (error) {
    console.warn('[Explore] Could not read sessionStorage', error);
    return defaultExploreState;
  }
}

export function writeExploreSession(state) {
  if (typeof window === 'undefined') return;
  try {
    window.sessionStorage.setItem(KEY, JSON.stringify({ ...state, updatedAt: new Date().toISOString() }));
  } catch (error) {
    console.warn('[Explore] Could not write sessionStorage', error);
  }
}

export function resetExploreSession() {
  if (typeof window === 'undefined') return;
  window.sessionStorage.removeItem(KEY);
}
